"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaContaPagar = exports.yupContaPagar = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupContaPagar = yup.object({
    idFornecedor: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Fornecedor'),
    idEmpresa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Empresa'),
    idPlanoDespesa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Plano Conta - Despesa'),
    data: (0, utils_1.sge2Date)().nullable().default(null).label('Data'),
    // --> dados da Parcela
    parcela: yup.string().default('').max(2, 'Máximo de 2 caracteres').required().label('Parcela'),
    dataVencimento: (0, utils_1.sge2Date)().nullable().default(null).label('Data Vencimento'),
    valorDocumento: yup.number().notRequired().label('Valor Documento'),
    percentualDesconto: yup.number().notRequired().label('Percentual Desconto Parcela'),
    valorParcela: yup.number().notRequired().label('Valor Parcela'),
    bloqueto: yup.string().default('').max(12, 'Máximo de 12 caracteres').label('Bloqueto'),
    // --> dados do Pagamento da Parcela
    dataPagamento: (0, utils_1.sge2Date)().nullable().default(null).label('Data Pagamento'),
    horaPagamento: yup.string().default('').max(6, 'Máximo de 6 caracteres').label('Hora Pagamento'),
    valorAcrescimo: yup.number().notRequired().label('Valor Acréscimo'),
    valorDesconto: yup.number().notRequired().label('Valor Desconto'),
    valorPago: yup.number().notRequired().label('Valor Pago'),
    numeroCheque: yup.string().default('').max(10, 'Máximo de 10 caracteres').label('Numero do Cheque'),
    tipoPagamento: yup.string().default('').max(1, 'Máximo de 1 caracteres').label('Tipo Pagamento'),
    // --> Outras informacoes
    tipo: yup.string().default('').max(15, 'Máximo de 15 caracteres').label('Tipo'),
    numeroConta: yup.string().default('').max(9, 'Máximo de 9 caracteres').label('Numero Conta'),
    observacao: yup.string().default('').max(250, 'Máximo de 250 caracteres').label('Observacao'),
    grupo: yup.number().notRequired().label('Grupo'),
    versaoLacamento: yup.number().notRequired().label('Versao do Lancamento'),
    usuario: yup.string().default('').max(3, 'Máximo de 3 caracteres').label('Usuario'),
});
exports.schemaContaPagar = exports.yupContaPagar.shape({});
